/* SET STATE */
export const SET_STATE_NOTIFICATIONMANAGER = "SET_STATE_NOTIFICATIONMANAGER"

/* NOTIFICATIONMANAGERS */
export const GET_NOTIFICATIONMANAGERS = "GET_NOTIFICATIONMANAGERS"
export const GET_NOTIFICATIONMANAGERS_SUCCESS = "GET_NOTIFICATIONMANAGERS_SUCCESS"
export const GET_NOTIFICATIONMANAGERS_FAIL = "GET_NOTIFICATIONMANAGERS_FAIL"


/* NOTIFICATIONMANAGER */
export const GET_NOTIFICATIONMANAGER = "GET_NOTIFICATIONMANAGER"
export const GET_NOTIFICATIONMANAGER_SUCCESS = "GET_NOTIFICATIONMANAGER_SUCCESS"
export const GET_NOTIFICATIONMANAGER_FAIL = "GET_NOTIFICATIONMANAGER_FAIL"

/**
 * ADD NOTIFICATIONMANAGER
 */
 export const ADD_NEW_NOTIFICATIONMANAGER = "ADD_NEW_NOTIFICATIONMANAGER"
 export const ADD_NOTIFICATIONMANAGER_SUCCESS = "ADD_NOTIFICATIONMANAGER_SUCCESS"
 export const ADD_NOTIFICATIONMANAGER_FAIL = "ADD_NOTIFICATIONMANAGER_FAIL"

 /**
 * UPDATE NOTIFICATIONMANAGER
 */
export const UPDATE_NOTIFICATIONMANAGER = "UPDATE_NOTIFICATIONMANAGER"
export const UPDATE_NOTIFICATIONMANAGER_SUCCESS = "UPDATE_NOTIFICATIONMANAGER_SUCCESS"
export const UPDATE_NOTIFICATIONMANAGER_FAIL = "UPDATE_NOTIFICATIONMANAGER_FAIL"

 /**
 * UPDATE NOTIFICATIONMANAGER
 */
  export const UPDATE_NOTIFICATIONMANAGERSTATUS = "UPDATE_NOTIFICATIONMANAGERSTATUS"
  export const UPDATE_NOTIFICATIONMANAGERSTATUS_SUCCESS = "UPDATE_NOTIFICATIONMANAGERSTATUS_SUCCESS"
  export const UPDATE_NOTIFICATIONMANAGERSTATUS_FAIL = "UPDATE_NOTIFICATIONMANAGERSTATUS_FAIL"

/**
 * DELETE NOTIFICATIONMANAGER
 */
export const DELETE_NOTIFICATIONMANAGER = "DELETE_NOTIFICATIONMANAGER"
export const DELETE_NOTIFICATIONMANAGER_SUCCESS = "DELETE_NOTIFICATIONMANAGER_SUCCESS"
export const DELETE_NOTIFICATIONMANAGER_FAIL = "DELETE_NOTIFICATIONMANAGER_FAIL"
